import React from 'react'
import { forwardRef } from 'react';
import DatePicker from "react-datepicker";
import { Controller } from 'react-hook-form';

import "react-datepicker/dist/react-datepicker.css";


const DatePickerController = ({
    name,
    control,
    defaultValue = null,
    handleDateChange,
    yearPicker,
    ...rest
}) => {
    const CustomInput = forwardRef(
        ({ value, onClick, className }, ref) => (
            <div onClick={onClick} className={`border border-gray-300 rounded-md p-2 w-full flex items-center justify-between h-[40px] px-[20px] ${className}`} ref={ref}>
                <span>
                    {value}
                </span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 mr-[10px]">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z" />
                </svg>
            </div>
        ),
      );
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({ field, formState: { errors } }) => (
                <>
                    <DatePicker
                        {...rest}
                        wrapperClassName='w-full'
                        isClearable
                        customInput={<CustomInput />}
                        selected={yearPicker ? new Date(field.value, 0, 1) : field.value}
                        onChange={(date) => {
                            const formatDate = yearPicker ? date.getFullYear() : date
                            field.onChange(formatDate)
                            if (handleDateChange) handleDateChange(formatDate);
                        }}
                    />
                    {
                        errors[name] && (
                            <p className="text-danger">
                                {errors[name]?.message}
                            </p>
                        )
                    }
                </>
            )
            }
        />
    )
}

export default DatePickerController